import React from 'react'
import { NEXT_IMAGE_QUALITY } from '~constants'
import cx from 'classnames'
import Image from 'next/image'
import parse from 'html-react-parser'
import { Col, Row } from 'react-grid-system'

import { Button, Heading } from '~elements'
import { ButtonProps, RichTextType } from '~types'

import styles from './Card.module.scss'

interface CardProps {
  backgroundImage: { url: string }
  cta: ButtonProps
  description: RichTextType
  headline: string
  icon?: { url: string }
  iconHeight?: number
  iconWidth?: number
}

const Card = ({ backgroundImage, cta, description, headline, icon, iconHeight, iconWidth }: CardProps) => {
  return (
    <>
      <Col sm={12}>
        <Row>
          <Col lg={12} className='align-contents-vertical'>
            <div className={cx([styles.card, styles['col-wrapper--content']])}>
              <div className={styles['col-wrapper--media']}>
                {backgroundImage?.url && (
                  <div className={styles['image-container']}>
                    <Image alt={headline || ''} src={backgroundImage.url} fill quality={NEXT_IMAGE_QUALITY} />
                  </div>
                )}
                {icon?.url && (
                  <div className={styles['media-column']}>
                    <Image
                      width={iconWidth}
                      height={iconHeight}
                      sizes='100vw'
                      alt={headline}
                      src={icon.url}
                      quality={NEXT_IMAGE_QUALITY}
                    />
                  </div>
                )}
              </div>
              {headline && <Heading level={3}>{headline}</Heading>}
              {description?.html && parse(description.html)}
              {cta && (
                <div className={styles.button}>
                  <Button
                    {...cta}
                    color='light'
                    fill='hollow'
                    size='md'
                    title={cta.title}
                    analytics={{
                      linkModule: 'card'
                    }}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </>
  )
}
export default Card
